import React, { useState, useEffect, useContext } from "react";
import { GlobalStateContext } from "../../GlobalStateProvider";

function GroupSelector({ indices }) {
  const [selectedValue, setSelectedValue] = useState("");
  const { index, indexType, setIndex, setIndexType } =
    useContext(GlobalStateContext);

  useEffect(() => {
    const lastindex = sessionStorage.getItem("index");
    const lastIndexType = sessionStorage.getItem("indexType");
    if (indices.length !== 0) {
      setSelectedValue(!lastindex ? indices[0].index : lastindex);
      setIndex(!lastindex ? indices[0].index : lastindex);
      setIndexType(!lastIndexType ? indices[0].type : lastIndexType);
      sessionStorage.setItem(
        "index",
        !lastindex ? indices[0].index : lastindex
      );
      sessionStorage.setItem(
        "indexType",
        !lastIndexType ? indices[0].type : lastIndexType
      );
    }
  }, [indices]);

  // console log whenever indexType changes
  useEffect(() => {
    console.log(index, ":", indexType);
  }, [index, indexType]);

  const handleIndexChange = (event) => {
    const selectedindex = event.target.value;

    // find selected index from indices and set indexType
    const matchedIndex = indices.find((index) => index.index === selectedindex);
    if (!matchedIndex) {
      console.error(
        `No matching index found for the selected index: ${selectedindex}`
      );
      return;
    }
    const type = matchedIndex.type;
    console.log("indexType", type)
    sessionStorage.setItem("index", selectedindex);
    sessionStorage.setItem("indexType", type);
    setSelectedValue(selectedindex);
    setIndex(selectedindex);
    setIndexType(type);
  };

  if (indices.length === 1) {
    return (
      <>
        <div className="selectList full">{indices[0].alias}</div>
        <div className="selectList sm">{indices[0].abbr}</div>
      </>
    );
  }

  return (
    <>
      <select
        className="selectList full"
        value={selectedValue}
        name="chatservice"
        id="chatservice"
        onChange={handleIndexChange}
        title="chat-service"
      >
        {indices.map(({ index, alias, abbr, disabled }, i) => (
          <option key={i} value={index} disabled={disabled}>
            {alias}
          </option>
        ))}
      </select>
      <select
        className="selectList sm"
        value={selectedValue}
        name="chatservice"
        id="chatservice"
        onChange={handleIndexChange}
        title="chat-service"
      >
        {indices.map(({ index, alias, abbr, disabled }, i) => (
          <option key={i} value={index} disabled={disabled}>
            {abbr}
          </option>
        ))}
      </select>
    </>
  );
}

export default GroupSelector;
